
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"13849f061b320415cc79e589e0b01bbf53a2c241":"startRewardfulImportAction","8dc70945c901983b78965abe3618e5811060a430":"$$ACTION_0"} */ export var startRewardfulImportAction = createServerReference("13849f061b320415cc79e589e0b01bbf53a2c241");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

